declare let kendo: any;

export class ValidateStringFunction {
  static register(registerFunc = kendo.spreadsheet.defineFunction) {
    registerFunc('VALIDATE_STRING', function (str) {
      return true;
    }).args([['str', 'string']]);
  }
}
